//import constanteApi from "@/conf-global.js";
export default {
    capitalizeWords: function (arr) {
        return arr.map(element => {
            return element.charAt(0).toUpperCase() + element.substring(1).toLowerCase();
        });
    },

    makeReadable: function (key) {
        return this.capitalizeWords(key.replaceAll('_', ' ').split(' ')).join(' ');
    },
    getConstantes: () => {
        try {
            axios.get('/constante/global').then((r) => {
                //console.log(r.data.constantes)
                return r.data.constantes
            }).catch((e) => {
              console.log(e)
            })
            
        } catch (error) {
              console.log('Error al consultar constantes', error)
              throw error
        }
    }
}